import { render } from "./IndustrialSafetyPage.vue?vue&type=template&id=ca0d002e&scoped=true"
import script from "./IndustrialSafetyPage.vue?vue&type=script&lang=js"
export * from "./IndustrialSafetyPage.vue?vue&type=script&lang=js"

import "./IndustrialSafetyPage.vue?vue&type=style&index=0&id=ca0d002e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca0d002e"]])

export default __exports__